import { useSelector } from 'react-redux'

/**
 * Custom hook for typed state selection
 * @template T
 * @param {(state: import('@/store').RootState) => T} selector - State selector function
 * @returns {T} Selected state
 * @example
 * const user = useAppSelector(selectUser)
 */
export const useAppSelector = useSelector
